import LanguageV2 from "../components/LanguageV2";
import {connect} from "react-redux";

const m2s = state => ({
	language: state.language
});

const m2d = dispatch => ({});

export default connect(m2s, m2d)(LanguageV2);